import { render, staticRenderFns } from "./approvalEmp.vue?vue&type=template&id=c598cf94&scoped=true"
import script from "./approvalEmp.vue?vue&type=script&lang=js"
export * from "./approvalEmp.vue?vue&type=script&lang=js"
import style0 from "./approvalEmp.vue?vue&type=style&index=0&id=c598cf94&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c598cf94",
  null
  
)

export default component.exports